import React from "react";
import { FaStar } from "react-icons/fa";
import { Link } from "react-router-dom";
import { BsArrowRight } from "react-icons/bs";

const Card = ({ data }) => {
  return (
    <div className="p-3 lg:p-5">
      <div>
        <img src={data?.image} className="w-full" alt={data?.given_name} />
      </div>
      <h2 className="text-[18px] leading-[30px] lg:text-[26px] lg:leading-9 text-dr_gray font-[700] mt-3 lg:mt-5">
        {data?.name ? data.name : `${data?.given_name} ${data?.family_name}`}
      </h2>
      <div className="mt-2 lg:mt-4 flex items-center justify-between">
        <span className="bg-h5 text-dr_gray p-1 px-2 lg:py-2 lg:px-6 text-[12px] leading-4 lg:text-[16px] lg:leading-7 font-semibold rounded">
          {data?.specialization}
        </span>
        {data?.avgRating && data?.totalRating ? (
          <div className="flex items-center gap-[6px]">
            <span className="flex items-center gap-[6px] text-[14px] leading-6 lg:text-[16px] lg:leading-7 font-semibold text-dr_gray">
              <FaStar color="#ffdd61" /> {data?.avgRating}
            </span>
            <span className="text-[14px] leading-6 lg:text-[16px] lg:leading-7 font-semibold text-dr_gray">
              ({data?.totalRating})
            </span>
          </div>
        ) : (
          ""
        )}
      </div>
      <div>
        {data?.workPlaces?.length
          ? data.workPlaces.map((elem, i) => (
              <span
                key={i}
                className="text-[14px] leading-6 font-[400] text-dr_gray"
              >
                {elem}
              </span>
            ))
          : ""}
      </div>
      <Link to={`/admin/${data?.id}`}>
        <div className="w-[44px] h-[44px] rounded-full border border-solid border-b-d_gray mt-[30px] mx-auto flex items-center justify-center group hover:bg-h5 hover:border-none">
          <BsArrowRight className="group-hover:text-white w-6 h-5 duration-300" />
        </div>
      </Link>
    </div>
  );
};

export default Card;
